import { RouterProvider } from 'react-router-dom';
import { AppProvider, ProgressProvider, ExperimentProvider } from '@/context';
import { router } from '@/routes';

export default function App() {
  return (
    <AppProvider>
      <ProgressProvider>
        <ExperimentProvider>
          <RouterProvider router={router} />
        </ExperimentProvider>
      </ProgressProvider>
    </AppProvider>
  );
}
